export const QGIS_DEV_BASE_URL = "https://gis.dev.hortatech.es";
export const QGIS_PROJECT_NAME = "hortatech_fibsen_operational";

const currentHostname = () =>
  typeof window === "undefined" ? "" : window.location.hostname;

export const getQgisBaseUrl = (
  hostname = currentHostname(),
  override = process.env.REACT_APP_QGIS_BASE_URL
) => {
  if (override) return override.replace(/\/$/, "");
  if (hostname === "dev.dashboard.hortatech.es") return QGIS_DEV_BASE_URL;

  // There is no approved PROD QGIS route. Local development must opt into a
  // compatible local or DEV stack explicitly through REACT_APP_QGIS_BASE_URL.
  return undefined;
};

export const qgisProjectUrl = (
  projectName,
  baseUrl = getQgisBaseUrl()
) =>
  baseUrl
    ? `${baseUrl.replace(/\/$/, "")}/projects/${encodeURIComponent(projectName)}/`
    : undefined;

export const QGIS_PROJECT_URL = qgisProjectUrl(QGIS_PROJECT_NAME);
